import { Component, OnInit } from '@angular/core';
import { RoleLoadAllAction } from '@modules/roles/store/role.actions';
import { UserLoadAction } from '@modules/users/store/user.actions';
import { User } from '@modules/users/users.interface';
import { Store, select } from '@ngrx/store';
import { AuthenticationService } from '@services/authentication.service';
import { ErrorService } from '@services/error.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import {
  canAdminInactiveUserCancellationChange,
  canAdminUserAddition,
  canAdminUserCancellation,
  canNotifyPasswordChange,
  canViewEvents,
  enableAgingFatture,
  enableExactAssociation,
  enablePrivacyTc,
  enableReviews,
  enableRicercaUtentiFb,
  enableSearchAssociation,
  enableSearchIrenYou,
  enableUserDuplicated,
  userExtraction
} from 'src/app/modules/permissions/store/permission.selectors';
import { currentUser, isDeveloper } from 'src/app/modules/users/store/user.selectors';
import { environment } from 'src/environments/environment';

export const darkMode$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

@Component({
  selector: 'iren-private-area',
  templateUrl: './private-area.component.html',
  styleUrls: ['./private-area.component.scss']
})
export class PrivateAreaComponent implements OnInit {
  environment = environment;
  isSuperAdmin$: Observable<boolean> = this.store.pipe(select(isDeveloper));
  enableUserCancellation$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(canAdminUserCancellation)));
  enableUserAddition$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(canAdminUserAddition)));
  enableForcePassword$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(canNotifyPasswordChange)));
  enableEvents$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(canViewEvents)));
  enableInactiveUserCancellation$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(canAdminInactiveUserCancellationChange)));
  enableUserDuplicated$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableUserDuplicated)));
  enableReviews$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableReviews)));
  enableExactAssociation$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableExactAssociation)));
  enableSearchIrenYou$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableSearchIrenYou)));
  userExtraction$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(userExtraction)));
  enableSearchAssociation$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableSearchAssociation)));
  enablePrivacyTc$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enablePrivacyTc)));
  enableAgingFatture$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableAgingFatture)));
  enableRicercaUtentiFb$: Observable<boolean> = this.isAdminOrYou(this.store.pipe(select(enableRicercaUtentiFb)));
  darkMode: boolean;
  public user: Partial<User>;

  constructor(private store: Store, private authenticationService: AuthenticationService, private errorService: ErrorService) {}

  ngOnInit(): void {
    this.store.dispatch(RoleLoadAllAction());
    this.store.dispatch(UserLoadAction());

    darkMode$.subscribe({
      next: value => {
        this.darkMode = value;
      }
    });

    this.store
      .select(currentUser)
      .pipe(
        filter(user => !!user.id_utente),
        take(1)
      )
      .subscribe({
        next: user => {
          this.user = user;
        },
        error: error => {
          const errorMessage = `Errore durante il recupero dei dati dell'utente`;
          this.errorService.setError(errorMessage);
        }
      });
  }

  private isAdminOrYou(you: Observable<boolean>) {
    return you.pipe(mergeMap(is => this.isSuperAdmin$.pipe(map(isAdmin => isAdmin || is))));
  }

  logout() {
    this.authenticationService.logout();
  }

  setDarkMode() {
    darkMode$.next(!this.darkMode);
  }
}
